const PartnerInformationEndpoint = {
  GET_MESSAGES_FOR_USER: '/default/partner-information/get-messages-for-user',
  MARK_MESSAGE_AS_READ: '/default/partner-information/mark-message-as-read',
};

export default PartnerInformationEndpoint;
